// Phase I0.5 — Club kit colour table for Super Acca / Daily Acca team
// monogram fallback rendering. Values are platform brand metadata
// (verbatim from prototype/data.jsx::TODAY_FIXTURES), not user data.
// When a club's licensed badge URL fails to load, <TeamLine> renders a
// 3-letter monogram on this kit colour.
//
// Keyed by short code (uppercase). Unknown clubs fall back to
// FALLBACK_KIT, which matches --sa-hairline so an unloaded badge renders
// as a quiet neutral tile rather than something that looks deliberate.

export const FALLBACK_KIT = "#1E1E1E";

export const KIT_COLORS: Readonly<Record<string, string>> = {
  WHU: "#7A263A",
  ARS: "#EF0107",
  BAY: "#DC052D",
  RBL: "#DD0741",
  RMA: "#FEBE10",
  SEV: "#D71920",
  INT: "#1E5BC6",
  ROM: "#7C2D2D",
  PSG: "#004170",
  LIL: "#E2231A",
  LIV: "#C8102E",
  BHA: "#0057B8",
  MCI: "#6CABDD",
  TOT: "#132257",
  BVB: "#FDE100",
  B04: "#E32219",
  BAR: "#A50044",
  ATM: "#CB3524",
  MIL: "#FB090B",
  JUV: "#000000",
  CHE: "#034694",
  NEW: "#241F20",
  EVE: "#003399",
  AVL: "#7A003C",
};

/** Returns the brand kit colour for a short code, falling back to neutral. */
export function kitColor(shortCode: string | null | undefined): string {
  if (!shortCode) return FALLBACK_KIT;
  return KIT_COLORS[shortCode.toUpperCase()] ?? FALLBACK_KIT;
}
